import type { SVGProps } from "react";

export function AirConditionerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4 7.5L7.15 9.3M7.15 9.3L12.1 12M7.15 9.3L4 10.2M7.15 9.3L6.7 6.15M20.2 16.5L17.05 14.7M17.05 14.7L12.1 12M17.05 14.7L17.5 17.85M17.05 14.7L20.2 13.8M12.1 12L7.15 14.7M12.1 12V5.7M12.1 12V17.85M12.1 12L17.05 9.3M7.15 14.7L4 16.5M7.15 14.7L4 13.8M7.15 14.7L6.7 17.85M12.1 5.7V3M12.1 5.7L9.85 4.8M12.1 5.7L14.35 4.8M12.1 17.85V21M12.1 17.85L14.35 19.2M12.1 17.85L9.85 19.2M17.05 9.3L20.2 7.5M17.05 9.3L20.2 10.2M17.05 9.3L17.5 6.15"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
